import { useEffect, useState } from "react";

import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";
import type { CompanyParsingErrors, ContactsParsingErrors, SupportTextProps } from "../../types";
import { StyledErrorContainer, StyledLoadListHint } from "../style";

const companyErrorsOrder: Array<keyof CompanyParsingErrors> = [
    "isOverTheLimit",
    "notADomains",
    "columnsNumber",
    "format",
];
const contactsErrorsOrder: Array<keyof ContactsParsingErrors> = [
    "emptyColumns",
    "noRequiredFields",
    "quotaExceeded",
    "isOverTheLimit",
    "format",
];

export const SupportText = ({
    errorTexts,
    hasError,
    parsingErrors,
    customHint,
    width,
    hasCustomTracking,
    type,
}: SupportTextProps) => {
    const [errorMessage, setErrorMessage] = useState<string | undefined>("");

    useEffect(() => {
        if (!errorMessage || hasCustomTracking) {
            return;
        }

        allTrackers.dispatchTrackEvent("suppression", `Error`, `account suppression/error/${translate(errorMessage)}`);
    }, [errorMessage, hasCustomTracking]);

    const checkAndSetErrorMessage = (
        errorKeys: Array<keyof CompanyParsingErrors> | Array<keyof ContactsParsingErrors>,
        errors: Record<string, boolean>,
    ) => {
        for (const key of errorKeys) {
            if (errors[key]) {
                setErrorMessage(errorTexts?.[key]);
                return;
            }
        }
    };

    useEffect(() => {
        if (type === "company") {
            checkAndSetErrorMessage(companyErrorsOrder, parsingErrors as CompanyParsingErrors);
        } else {
            checkAndSetErrorMessage(contactsErrorsOrder, parsingErrors as ContactsParsingErrors);
        }
    }, [hasError, parsingErrors, errorTexts, type]);

    if (hasError && errorMessage) {
        return <StyledErrorContainer>{translate(errorMessage)}</StyledErrorContainer>;
    }

    return customHint ? <StyledLoadListHint style={{ width }}>{customHint}</StyledLoadListHint> : null;
};
